/**
 * Custom Product Options — Color Swatch Selection & Form Validation
 *
 * Handles swatch clicks, hidden input updates, selected label display,
 * and add-to-cart validation for required options.
 * Price adjustments (woodgrain, delivery, etc.) are all handled via
 * Shopify variants — no client-side price logic needed.
 */
(function () {
  'use strict';

  var CONTAINER_SELECTOR = '[data-custom-options]';
  var GROUP_SELECTOR = '[data-option-group]';
  var SWATCH_SELECTOR = '.custom-swatch';
  var INPUT_SELECTOR = '[data-option-input]';
  var LABEL_SELECTOR = '[data-selected-label]';
  var ERROR_SELECTOR = '[data-option-error]';
  var FORM_SELECTOR = 'form[data-type="add-to-cart-form"]';

  function initContainer(container) {
    var groups = container.querySelectorAll(GROUP_SELECTOR);
    groups.forEach(function (g) { initGroup(g); });
    interceptFormSubmit(container);
  }

  function initGroup(group) {
    var swatches = group.querySelectorAll(SWATCH_SELECTOR);
    var input = group.querySelector(INPUT_SELECTOR);
    var label = group.querySelector(LABEL_SELECTOR);

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var value = swatch.getAttribute('data-swatch-value');

        swatches.forEach(function (s) {
          s.classList.remove('is-selected');
          s.setAttribute('aria-checked', 'false');
        });

        swatch.classList.add('is-selected');
        swatch.setAttribute('aria-checked', 'true');

        if (input) {
          input.value = value;
        }

        if (label) {
          label.textContent = value;
        }

        clearError(group);
      });
    });
  }

  function clearError(group) {
    var error = group.querySelector(ERROR_SELECTOR);
    if (error) {
      error.hidden = true;
    }
  }

  function showError(group) {
    var error = group.querySelector(ERROR_SELECTOR);
    if (error) {
      error.hidden = false;
    }
  }

  function interceptFormSubmit(container) {
    var firstInput = container.querySelector(INPUT_SELECTOR);
    if (!firstInput) return;

    var form = null;
    var formId = firstInput.getAttribute('form');
    if (formId) {
      form = document.getElementById(formId);
    }
    if (!form) {
      form = container.closest(FORM_SELECTOR);
    }
    if (!form) {
      form = document.querySelector(FORM_SELECTOR);
    }
    if (!form) return;

    form.addEventListener('submit', function (e) {
      if (!validateOptions(container)) {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    var formComponent = form.closest('product-form-component');
    if (formComponent) {
      var origSubmit = formComponent.handleSubmit;
      if (typeof origSubmit === 'function') {
        formComponent.handleSubmit = function (event) {
          if (!validateOptions(container)) {
            if (event && typeof event.preventDefault === 'function') {
              event.preventDefault();
            }
            return;
          }
          return origSubmit.call(formComponent, event);
        };
      }
    }
  }

  function validateOptions(container) {
    var valid = true;
    var firstInvalid = null;
    var groups = container.querySelectorAll(GROUP_SELECTOR);

    groups.forEach(function (group) {
      var isRequired = group.getAttribute('data-required') === 'true';
      if (!isRequired) return;

      var input = group.querySelector(INPUT_SELECTOR);
      if (!input) return;

      var value = input.value.trim();
      if (!value) {
        valid = false;
        showError(group);
        if (!firstInvalid) {
          firstInvalid = group;
        }
      } else {
        clearError(group);
      }
    });

    if (firstInvalid) {
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    return valid;
  }

  function init() {
    var containers = document.querySelectorAll(CONTAINER_SELECTOR);
    containers.forEach(initContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
